import { useState } from 'react';
import { Link } from 'react-scroll';
import './Nav.scss';
import closeButton from '../../assets/img/close.svg';
import sal from '../../assets/img/sal.png';
const menuItems = [
  {
    url: 'food-scarcity',
    text: 'Food Scarcity'
  },
  {
    url: 'generational-poverty',
    text: 'Generational Poverty'
  },
  {
    url: 'youth-homelessness',
    text: 'Youth Homelessness'
  }
];

const Nav = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  return (
    <div className="nav">
      <div className="nav__hamburger" onClick={() => setIsNavOpen(!isNavOpen)}>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <img className="nav__sal-logo" src={sal} alt="salvation army logo" />
      <div className={`sub-nav ${isNavOpen ? 'sub-nav--opened' : ''}`}>
        <div onClick={() => setIsNavOpen(false)} className="sub-nav__close-button">
          <span>
            <img alt="close button" src={closeButton} />
          </span>
        </div>
        <div className="sub-nav__menu">
          {menuItems &&
            menuItems.map((item) => {
              return (
                <p>
                  <Link
                    activeClass="active"
                    to={item.url}
                    spy={true}
                    smooth={true}
                    duration={500}
                    onClick={() => setIsNavOpen(false)}
                  >
                    {item.text}
                  </Link>
                </p>
              );
            })}
          <p>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://give.salvationarmyusa.org/give/164006/?gclid=Cj0KCQiAsqOMBhDFARIsAFBTN3cA0t5j3GAzsfW-aCDSXl5EcwwhZDe-AqRQ75CbfE-L_l0ASn0Ib-kaAmFhEALw_wcB#!/donation/checkout?utm_source=google_lerma&utm_medium=cpc&utm_term=general_brand&utm_content=text&utm_campaign=edonation_eastern_brand&pid=cpc:edonation_eastern_brand::google_lerma:::::eastern_eastern:general_brand:evergreen"
              className="donate-now"
            >
              Donate Now
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
export default Nav;
